function TopGainersLosersCard(props) {
  const columns = props.data.columns.map((item, idx) =>
    <ColumnTitle key={idx} text={item} />
  );
  const entries = props.data.items.map((item, idx) =>
    <Entry
      key={idx}
      text={item.text}
      percent={item.percent}
      recommendation={item.recommendation}
      recommendationBadgeClass={item.recommendationBadgeClass}
    />
  );

  return (
    <div className="col-12 col-xl-3">
      <div className="card border-light shadow-sm">
        <div className="card-header">
          <div className="row align-items-center">
            <div className="col">
              <h2 className="h5 mb-0">{props.title}</h2>
            </div>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table align-items-center table-flush top-movers-table">
            <thead className="thead-light">
              <tr>{columns}</tr>
            </thead>
            <tbody>{entries}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function ColumnTitle(props) {
  return (<th scope="col">{props.text}</th>);
}

function Entry(props) {
  const UpArrow = "fa-arrow-up text-success";
  const DownArrow = "fa-arrow-down text-danger";
  const ArrowToUse = props.percent > 0 ? UpArrow : DownArrow;

  return (
    <tr>
      <th scope="row">{props.text}</th>
      <td>
        <div className="d-flex align-items-center justify-content-end">
          {props.recommendation && props.recommendationBadgeClass && (
            <span className={`badge badge-pill analyst-rating-pill ${props.recommendationBadgeClass} mr-2`}>
              {props.recommendation}
            </span>
          )}
          <span className={"fas mr-2 " + ArrowToUse}></span>
          <span>{props.percent}%</span>
        </div>
      </td>
    </tr>
  );
}

export default TopGainersLosersCard;
